import Vue from 'vue'
import Vuex from 'vuex'

Vue.use( Vuex )

export default new Vuex.Store( {
    state: {
        totalPages: null,
        order: 'relevance:desc',
        page: null,
        total: null,
        s: null,
        taxonomies: [],
        years: [],
        post_type: [],
        filtersActive: false,
        focusFilter: null
    },
    getters: {
        s: state => state.s,
        totalPages: state => state.totalPages,
        total: state => state.total,
        order: state => state.order,
        page: state => state.page,
        filtersActive: state => state.filtersActive,
        query( state ) {
            const orderBy = state.order.split( ':' )[ 0 ]
            const order = state.order.split( ':' )[ 1 ]

            let params = [ `?s=${ state.s }`, `paged=${ state.page }`, `orderby=${ orderBy }`, `order=${ order }` ]

            const taxonomyParams = state.taxonomies.map( ( { taxonomy, slug }, index ) => {
                return `taxonomies[${ taxonomy }][${ index }]=${ slug }`
            } )

            const yearParams = state.years.map( ( year, index ) => `years[${ index }]=${ year }` )
            const postTypeParams = state.post_type.map( ( postType, index ) => `post_type[${ index }]=${ postType }` )
            const query = [].concat( params, taxonomyParams, yearParams, postTypeParams )
            return query.join( '&' )
        },
        focusFilter: state => state.focusFilter,
    },
    mutations: {
        addTaxonomy( state, payload ) {
            state.taxonomies.push( payload )
        },
        addYear( state, payload ) {
            state.years.push( payload )
        },
        addPostType( state, payload ) {
            state.post_type.push( payload )
        },
        removeTaxonomy( state, { slug, taxonomy } ) {
            state.taxonomies = state.taxonomies.filter( ( { slug: s, taxonomy: t } ) => s !== slug && t !== taxonomy )
        },
        removeYear( state, { slug } ) {
            state.years = state.years.filter( year => year !== slug )
        },
        removePostType( state, { slug } ) {
            state.post_type = state.post_type.filter( postType => postType !== slug )
        },
        setS( state, s ) {
            state.s = s
        },
        setHeaders( state, { totalPages, total } ) {
            state.totalPages = totalPages
            state.total = total
        },
        setPage( state, page ) {
            state.page = page
        },
        setOrder( state, order ) {
            state.order = order
        },
        setFiltersActive( state, value ) {
            state.filtersActive = value
        },

        /**
         * Store last clicked filter for the .focus() which is needed for a11y.
         */
        setLastClickedFilter( state, input) {
            state.focusFilter = input;
        }
    },
    actions: {
        addFilter( { commit }, { type, slug, taxonomy } ) {
            switch ( type ) {
                case 'taxonomy':
                    commit( 'addTaxonomy', { slug, taxonomy } )
                    break;
                case 'year':
                    commit( 'addYear', slug )
                    break;
                case 'post_type':
                    commit( 'addPostType', slug )
                    break;
            }
        },
        removeFilter( { commit }, { type, slug, taxonomy } ) {
            switch ( type ) {
                case 'taxonomy':
                    commit( 'removeTaxonomy', { slug, taxonomy } )
                    break;
                case 'year':
                    commit( 'removeYear', { slug } )
                    break;
                case 'post_type':
                    commit( 'removePostType', { slug } )
                    break;
            }
        },
        setS( { commit }, s ) {
            commit( 'setS', s )
        },
        setHeaders( { commit }, { totalPages, total } ) {
            commit( 'setHeaders', { totalPages, total } )
        },
        setPage( { commit }, page ) {
            commit( 'setPage', page )
        },
        setOrder( { commit }, order ) {
            commit( 'setOrder', order )
        },
        activateFilters( { commit } ) {
            commit( 'setFiltersActive', true )
        },
        deactivateFilters( { commit } ) {
            commit( 'setFiltersActive', false )
        },
        a11yLastClicked( { commit }, input ) {
            commit( 'setLastClickedFilter', input )
        }
    },
} )
